import React, { useEffect, useState } from "react";

import "./checkbox.css";
import AmountIncrease from "./amountIncrease";

interface CheckboxProps {
    onClick: (v: boolean) => void;
    label: string | React.ReactNode;
    value: boolean;
    amount?: number;
    available?: number;
    className?: string;
    changeAmount?: (v: number) => void;
}

export default function Checkbox(props: CheckboxProps) {

    return <div className={"checkbox-wrapper" + (props.value ? " checked" : "") + (props.className ? " " + props.className : "")}>
        <div onClick={() => {
        props.onClick(!props.value);
    }} className="checkbox-circle">
            <label className="cbx" htmlFor="cbx-46"><span>
                <svg width="12px" height="10px" viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                </svg></span>
            </label>
        </div>
        <a className="label" onClick={() => {
        props.onClick(!props.value);
    }}>{props.label}</a>
        {props.changeAmount && props.amount ? <AmountIncrease amount={props.amount} onChange={props.changeAmount}/> : <></>}
        {props.available ? <a className="grey amount">{props.available}</a> : <></>}
    </div>
}